import vehicleService from '../services/vehicleService';

const initialState = {
  // vehicle of interest from vin decode
  vehicleInfo: {},
  vehicleType: null,
  vehicleCategoryType: null, // radio button - auto or recreational
  vehicleCategory: null,
};

const getters = {
  vehicleString: state =>
    state.vehicleInfo
      ? `${state.vehicleInfo.year} ${state.vehicleInfo.make} ${state.vehicleInfo.model}${
          state.vehicleInfo.trim ? ` ${state.vehicleInfo.trim}` : ''
        }`
      : null,
  vehicleYear: state => state.vehicleInfo.year,
};

const mutations = {
  SET_STATE(state, [key, data]) {
    state[key] = data;
  },
  SET_VEHICLE_INFO(state, data) {
    state.vehicleInfo = data;
  },
  UPDATE_VEHICLE_INFO(state, data) {
    state.vehicleInfo = {
      ...state.vehicleInfo,
      ...data,
    };
  },
};

const actions = {
  async decodeVin({ rootState, commit }, { vin, make, model, trim }) {
    if (vin) {
      try {
        const res = await vehicleService.decodeVin(
          vin,
          rootState.business.api.key,
          rootState.business.api.externalID,
          make,
          model,
          trim
        );
        commit('SET_VEHICLE_INFO', res.data.vehicle);
      } catch (error) {
        commit('SET_VEHICLE_INFO', null);
        throw error;
      }
    } else {
      // If no vin provided, set the vehicle info to null
      commit('SET_VEHICLE_INFO', null);
      throw new Error('No vin provided.');
    }
  },
};

export default {
  namespaced: true,
  state: initialState,
  mutations,
  actions,
  getters,
};
